// The question screen's footer line (Rounds' voice: sentence case, plain, no exclamation marks). Where a tap locks the
// answer, it gives that rule; number, order and pick-all lock in with their own button and say nothing here. The intro
// card has already named the format and said how it works (screens/parts/copy.ts), so nothing here repeats it.
import type { PublicItem } from '@shared/types';

export const LOCK_RULE = 'Your first tap is your answer.';

export function answerHint(q: Pick<PublicItem, 'format' | 'multi'>): string | undefined {
  switch (q.format) {
    case 'number':
    case 'order':
      return undefined;
    case 'multi': return q.multi?.mode === 'rarity' ? LOCK_RULE : undefined;
    default: return LOCK_RULE;
  }
}
